import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://pdfconvertor.shop';
const SITE_NAME = 'pdfconvertor.shop';
const DEFAULT_IMAGE = `${SITE_URL}/pdflogo.jpg`;

const Seo = ({
    title,
    description,
    path = '/',
    image = DEFAULT_IMAGE,
    type = 'website',
    noindex = false,
    jsonLd,
    children,
}) => {
    const url = `${SITE_URL}${path}`;
    const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
    const ldArray = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {noindex ? (
                <meta name="robots" content="noindex, follow" />
            ) : (
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
            )}

            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:locale" content="en_US" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {ldArray.map((data, i) => (
                <script key={i} type="application/ld+json">
                    {JSON.stringify(data)}
                </script>
            ))}

            {children}
        </Helmet>
    );
};

export default Seo;
export { SITE_URL, SITE_NAME, DEFAULT_IMAGE };
